import { COMMUNITY_SUBSCRIPTION_PAGE_ROUTE } from "../../_pages/community-settings/community-subscription.page";

interface Props {
  isAvailable: boolean;
  className?: string;
}
/**
 * @param {boolean} isAvailable - Whether the premium is available or not.
 * @param {string} className - Optional class name.
 * @description This component is used to display a premium chip.
 */
export default function PremiumChip({ isAvailable, className }: Props) {
  if (!isAvailable) {
    return (
      <button
        onClick={() => {
          window.location.href = COMMUNITY_SUBSCRIPTION_PAGE_ROUTE;
        }}
        className={`rounded px-1 bg-yellow-100 text-yellow-900 text-xs font-semibold border border-yellow-400 ${className}`}>
        <div
          className=" flex items-center"
          onClick={(e) => {
            e.preventDefault();
          }}>
          <span>🌟 Pro</span>
        </div>
      </button>
    );
  }
  return null;
}
